import { LOCATION_CHANGE } from 'connected-react-router';
import {
  BusinessActions,
  UserActions,
  UtilActions,
  WalletActions,
  checkIfUserExist,
  checkIfBusinessListLoaded,
  CampaignActions, InfluencerActions, // InfluencerActions,
} from '../';
import { WALLET_TYPES, WALLET_SET_METAMASK_IS_LOADING } from '../../constants';
import walletManager from '../../_core/wallet-manager';
import TwoKeyStorage from '../../_core/2KeyStorage';
import { SUBMODULES } from '../../constants/campaign';
import { authHelpers } from '../../Auth/helpers';
import { campaignLandingRegexp } from '../../constants/regex';

// eslint-disable-next-line max-len
export const businessRegex = /^.*page(?!(.*join)|(.*create)|(.*Qm[a-zA-Z0-9]{44})|(.*participation\/contributionDetails)).*|^.*page((.*\/campaign\/create)|(.*\/campaign\/.*\/edit)).*$/;
// replaced by see above on 28.08.2019 /^.*page(?!(.*join)|(.*create)|(.*Qm.{44})|(.*participation\/contributionDetails)).*|^.*page(.*\/campaign\/create).*$/; // eslint-disable-line

// export const businessRegex = /^.*page(?!(.*join)|(.*create)).*|^.*page(.*\/campaign\/create).*$/;

// eslint-disable-next-line max-len
const personalRegex = /^.*(i\/|wallet|settings|Qm[a-zA-Z0-9]{44}|participation\/contributionDetails|page\/create|pay_forward=true).*$/;

let route = '';

const isAuthenticated = () => {
  const expiresAt = TwoKeyStorage.getItem('expires_at') ? parseInt(TwoKeyStorage.getItem('expires_at'), 10) : 0;
  return TwoKeyStorage.getItem('access_token') && new Date().getTime() < expiresAt;
};

const checkInitialDataLoading = store => {
  if (!isAuthenticated()) {
    return true;
  }
  const { business, user } = store.getState();
  const loading = business.get('listLoading');
  const initial = business.get('initial');
  const userId = user.getIn(['userMetadata', 'id']);
  return (initial || !loading) && (!authHelpers.isAuthenticated() || userId);
};

const checkWallet = (business, store, action, contractor) => {
  if (!isAuthenticated()) {
    return;
  }
  const state = store.getState();
  const isWalletChecking = state.wallet.get('loading');
  const unlock = action.payload.location.pathname.includes('unlock-wallet');
  let data;
  if (business) {
    if (!contractor) {
      const handle = action.payload.location.pathname.replace('/page/', '').split('/')[0];
      const businesses = Object.values(state.business.get('businessList').toJS());
      console.log('OWN BUSINESSES', businesses);
      data = businesses.find(item => item.handle === handle || item.id.toString() === handle);
    } else {
      data = { ...contractor };
    }
  } else {
    data = state.user.get('userMetadata').toJS();
  }
  console.log('CHECK WALLET MIDDLEWARE', business, data, action.payload.location.pathname, unlock);
  const address = state.wallet.getIn(['walletMeta', 'local_address']);
  if (!isWalletChecking && data && (!address || (data.web3_address && !data.web3_address.includes(address)))) {
    store.dispatch(WalletActions.CHECK_WALLET_BACKGROUND(data, business)).catch(console.log);
  } else if (!isWalletChecking && business && data && !data.web3_address) {
    store.dispatch(WalletActions.CHECK_WALLET_BACKGROUND(data, business, true)).catch(console.log);
    // } else if (unlock && !data.web3_address) {
  } else if (!isWalletChecking && data && !data.web3_address) {
    store.dispatch(WalletActions.CHECK_WALLET_BACKGROUND(data, business, true)).catch(console.log);
  } else if (data && data.web3_address.includes(address)) {
    store.dispatch(UtilActions.SET_BUSINESS_MODE({
      isBusinessMode: business,
      pathname: action.payload.location.pathname,
    }));
  }
};

export const setBusinessMode = (business, store, action, contractor) => {
  console.log('setBusinessMode', business);
  const state = store.getState();
  let isBusinessMode = state.general.get('isBusinessMode');
  const { location: { pathname } } = action.payload;
  console.log('isBusinessMode', isBusinessMode);
  if (!business && (isBusinessMode || isBusinessMode === null)) {
    store.dispatch(UtilActions.SET_BUSINESS_MODE({ isBusinessMode: false, pathname }));
    isBusinessMode = false;
  }
  let owner;
  if (business) {
    if (isBusinessMode) {
      store.dispatch(UtilActions.SET_BUSINESS_MODE_PATH(pathname));
    } else {
      if (!contractor) {
        const lastManagedBusinessHandle = state.user.getIn(['userMetadata', 'last_managed_business_handle']);
        const handle = pathname.replace('/page/', '').split('/')[0] || lastManagedBusinessHandle;
        const businesses = Object.values(state.business.get('businessList').toJS());

        if (handle) {
          owner = businesses.find(item =>
            item.handle.toLowerCase() === handle.toLowerCase() || item.id.toString() === handle);
          console.log('OWNER', {
            owner, businesses, handle, pathname,
          });
        }
      } else {
        owner = { ...contractor };
      }
      if (owner) {
        console.log('SET_BUSINESS_MODE', true);
        store.dispatch(UtilActions.SET_BUSINESS_MODE({ isBusinessMode: true, pathname }));
        isBusinessMode = true;
      } else {
        store.dispatch(UtilActions.SET_BUSINESS_MODE({ isBusinessMode: false, pathname }));
        isBusinessMode = false;
      }
    }
  }
  console.log('BUSINESS_MODE', isBusinessMode);
  checkWallet(isBusinessMode, store, action, owner);
};

const setBusinessModeAndCheckWallet = async(store, action) => {
  const { payload: { location: { pathname } } } = action;
  console.log(
    'LOCATION CHANGE setBusinessModeAndCheckWallet',
    pathname,
    businessRegex.test(pathname),
    personalRegex.test(pathname),
    campaignLandingRegexp.test(pathname)
  );
  if (pathname.startsWith('/page')) {
    const handle = action.payload.location.pathname.replace('/page/', '').split('/')[0];
    if (handle && handle !== 'create') {
      console.log('LOAD_ALL_DATA_FOR_BUSINESS', handle);
      store.dispatch(BusinessActions.LOAD_ALL_DATA_FOR_BUSINESS({ handleOrId: handle, resetCampaignData: true }));
    }
  }
  const state = store.getState();
  const lastManagedBusinessHandle = state.user.getIn(['userMetadata', 'last_managed_business_handle']);
  if (businessRegex.test(pathname) && pathname.replace('/page', '').trim()) {
    console.log(
      'setBusinessModeAndCheckWallet',
      businessRegex.test(pathname) && pathname.replace('/page', '').trim(),
      businessRegex.test(pathname),
      pathname.replace('/page', '').trim()
    );
    return setBusinessMode(true, store, action);
  }
  if (personalRegex.test(pathname)) {
    if (campaignLandingRegexp.test(pathname)) {
      try {
        console.log('campaignLandingRegexp');
        const {
          contractor, campaign_web3_address, campaign_type, campaign,
        } = await walletManager.getCampaignOffchainData(pathname.match(/Qm[a-zA-Z0-9]{44}/)[0]);
        let campaignPublicAddress;

        if (campaign_type === SUBMODULES.CPC) {
          campaignPublicAddress = await walletManager.getMirrorContractPlasma(campaign);
        }
        if (state.user.getIn(['userMetadata', 'owner_campaign_web3_addresses']).includes(campaign_web3_address) ||
          state.user.getIn(['userMetadata', 'owner_campaign_web3_addresses']).includes(campaignPublicAddress)) {
          console.log('FOUND CONTRACTOR');
          const businesses = Object.values(state.business.get('businessList').toJS());

          const contractorPage = businesses.find(item =>
            (item.web3_address && item.web3_address.toLowerCase() === contractor.toLowerCase())
            || (item.plasma_address && item.plasma_address.toLowerCase() === contractor.toLowerCase()));
          console.log('businesses', !!contractorPage, contractorPage, businesses);
          return setBusinessMode(!!contractorPage, store, action, contractorPage);
        }
        console.log('setBusinessModeAndCheckWallet', personalRegex.test(pathname));
        return setBusinessMode(false, store, action);
      } catch (e) {
        console.log('ERROR', e);
        console.log('setBusinessModeAndCheckWallet', personalRegex.test(pathname));
        return setBusinessMode(false, store, action);
      }
    }
    console.log('setBusinessModeAndCheckWallet', personalRegex.test(pathname));
    return setBusinessMode(false, store, action);
  }
  if (pathname === '/') {
    console.log('setBusinessModeAndCheckWallet', pathname === '/', !!lastManagedBusinessHandle);
    // return setBusinessMode(!!lastManagedBusinessHandle, store, action);
    return setBusinessMode(false, store, action);
  }
  console.log('FUCKUP', pathname);
  return pathname;
};

const whiteListActions = {
  CAMPAIGN_LOADING_PROCESS: CampaignActions.CAMPAIGN_LOADING_PROCESS,
  REFRESH_DASHBOARD_METRICS: BusinessActions.REFRESH_DASHBOARD_METRICS,
  GET_MY_PURCHASES: InfluencerActions.GET_MY_PURCHASES,
  SET_CLAIM_REWARD_MODAL: InfluencerActions.SET_ACTIVE_REWARD,
};

let currentWalletAddress = '0x0';

export default store => next => action => {
  if (action.type === 'REPLACE_2KEY_PROTOCOL') {
    console.log('REPLACE_2KEY_PROTOCOL', action.payload);
    store.dispatch(WalletActions.GET_2KEY_RELEASE_DATE());
  }

  if (action.type === 'LOCK_WALLETCONNECT') store.dispatch(WalletActions.lockWalletConnect);

  if (action.type === 'SET_GLOBAL_WALLET_REQUIRED_MODAL' && action.payload) {
    console.log('SET_GLOBAL_WALLET_REQUIRED_MODAL', action);
    const callbackAction = action.payload.type ? {
      type: action.payload.type,
      payload: action.payload.payload,
    } : action.payload.callback;
    const state = store.getState();
    const walletType = state.general.get('isBusinessMode')
      ? state.business.getIn(['businessDetails', 'business', 'registration_wallet_type'])
      : state.user.getIn(['userMetadata', 'registration_wallet_type']);
    const web3_address = state.general.get('isBusinessMode')
      ? state.business.getIn(['businessDetails', 'business', 'web3_address'])
      : state.user.getIn(['userMetadata', 'web3_address']);
    if (walletType === WALLET_TYPES.mm) {
      const initMM = () => new Promise((resolve, reject) => {
        store.dispatch(WalletActions[WALLET_SET_METAMASK_IS_LOADING](true));
        let timeout;
        timeout = setTimeout(() => {
          reject();
        }, 300);
        console.log('before initMM');
        walletManager.initMM().then(data => {
          console.log('MMM', data);
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
            resolve(data);
          }
        });
      });
      initMM().then(mm => {
        if ((Array.isArray(mm) && mm[0].toLowerCase() === web3_address.toLowerCase())
          || (typeof mm === 'boolean' && mm && walletManager.getMetaMaskCurrentAccount() === web3_address)) {
          console.log('IF');
          const data = (state.general.get('isBusinessMode')
            ? state.business.getIn(['businessDetails', 'business'])
            : state.user.get('userMetadata')).toJS();
          store.dispatch(WalletActions
            .CHECK_WALLET_BACKGROUND(data, state.general.get('isBusinessMode'), !data.web3_address))
            .then(async() => {
              await store.dispatch(WalletActions.GET_BALANCE(web3_address)).catch(console.warn);
              if (callbackAction) {
                if (typeof callbackAction === 'function') {
                  console.log('EXECUTING_CALLBACK');
                  callbackAction();
                } else {
                  store.dispatch(callbackAction);
                }
              }
            }).catch(() => {
              next(action);
            });
        } else {
          next(action);
        }
      }).catch(err => {
        console.warn('initMM', err);
        next(action);
      })
        .finally(() => {
          store.dispatch(WalletActions[WALLET_SET_METAMASK_IS_LOADING](false));
        });
    } else {
      next(action);
    }
  } else {
    next(action);
    const asyncAction = whiteListActions[action.type];

    if (store.getState().wallet.getIn(['walletMeta', 'local_address'])
      && store.getState().wallet.getIn(['walletMeta', 'local_address']) !== currentWalletAddress) {
      const isBusinessMode = store.getState().general.get('isBusinessMode');
      const businessId = store.getState().business.getIn(['businessDetails', 'id']);
      currentWalletAddress = store.getState().wallet.getIn(['walletMeta', 'local_address']);

      store.dispatch(WalletActions.GET_USD_RATES());
      store.dispatch(WalletActions.GET_BALANCE()).catch(console.warn);
      store.dispatch(WalletActions.GET_OPTIMAL_GAS_PRICE());

      // This is added here because loadWallet in CHECK_WALLET_INTERACTIVE
      // is not called for WalletConnect
      if (walletManager.web3 && walletManager.web3.currentProvider.isWalletConnect) {
        store.dispatch(WalletActions.SET_WALLET_TYPE_WALLET_CONNECT());
      }

      if (businessId) store.dispatch(WalletActions.GET_WALLET_TOKENS_LIST(businessId, isBusinessMode));
    }
    if (asyncAction) {
      // re-calls 'dispatch' function, that was stopped during unlocking the wallet
      store.dispatch(asyncAction(action.payload));
    }
    if (action.type === LOCATION_CHANGE && route !== action.payload.location.pathname) {
      route = action.payload.location.pathname;
      console.log('LOCATION_CHANGE WALLET', LOCATION_CHANGE, action.payload);
      if (store.getState().wallet.getIn(['transactionState', 'active'])) {
        store.dispatch(WalletActions.CLOSE_TRANSACTION_MODAL());
      }
      if (!checkInitialDataLoading(store)) {
        const state = store.getState();
        const userProfileError = state.user.get('userProfileError');
        const businessListError = state.business.get('businessListError');
        if (!userProfileError && !businessListError) {
          const listLoading = state.business.get('listLoading');
          const userLoading = state.user.get('loading');
          const initial = state.business.get('initial');
          if (!listLoading && !userLoading && !initial) {
            console.log('INITIAL LOAD DATA');
            Promise.all([
              store.dispatch(BusinessActions.FETCH_BUSINESS_LIST()),
              store.dispatch(UserActions.FETCH_USER_METADATA(true)),
            ])
              .then(() => {
                console.log('INITIAL LOADED');
              })
              .catch(() => {
              }).finally(() => {
                console.log('setBusinessModeAndCheckWallet_FINALLY', action);
                setBusinessModeAndCheckWallet(store, action);
              });
          } else {
            Promise.all([checkIfBusinessListLoaded(store.getState), checkIfUserExist(store.getState)])
              .then(() => {
                console.log('setBusinessModeAndCheckWallet_PROMISE', action);
                setBusinessModeAndCheckWallet(store, action);
              }).catch(() => {});
          }
        }
      } else {
        console.log('setBusinessModeAndCheckWallet_ELSE', action);
        setBusinessModeAndCheckWallet(store, action);
      }
    }
  }
};
